import fetchData from "./Fetch";
import { postData } from "./Post";
import { putData } from "./Put";

export const fetchDeviceConfig = async (devEui) => {
  return await fetchData(`/device-config/${devEui}`);
};

export const createDeviceConfig = async (data) => {
  return await postData("/device-config/", data);
};

export const updateDeviceConfig = async (devEui, data) => {
  return await putData(`/device-config/${devEui}`, data);
};
